import Badge from "ds/components/Badge";
import { OpenTofuMigrationState } from "types/generated";

import {
  OPEN_TOFU_MIGRATION_FAILED_MIGRATION_TEXT,
  OPEN_TOFU_MIGRATION_FAILED_ROLLBACK_TEXT,
  OPEN_TOFU_MIGRATION_STATES,
  TERRAFORM_VENDOR_CONFIG_TYPENAME,
} from "./constants";

type OpenTofuMigrationStateBadgeProps = {
  state: OpenTofuMigrationState;
  vendorConfigTypename?: string;
};

const OpenTofuMigrationStateBadge = ({
  state,
  vendorConfigTypename,
}: OpenTofuMigrationStateBadgeProps) => {
  const { variant, text } = OPEN_TOFU_MIGRATION_STATES[state];

  const failedText =
    vendorConfigTypename === TERRAFORM_VENDOR_CONFIG_TYPENAME
      ? OPEN_TOFU_MIGRATION_FAILED_MIGRATION_TEXT
      : OPEN_TOFU_MIGRATION_FAILED_ROLLBACK_TEXT;

  return (
    <Badge
      type="strong"
      variant={variant}
      text={state === OpenTofuMigrationState.Failed ? failedText : text}
    />
  );
};

export default OpenTofuMigrationStateBadge;
